class PathrohiCatalogue extends HTMLElement {
  connectedCallback() {
    this.classList.add('is-enhanced');
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick = (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest('[data-load-more]');
    if (!(button instanceof HTMLAnchorElement) || !this.contains(button)) return;

    event.preventDefault();
    this.loadNextPage(button);
  };

  async loadNextPage(button) {
    if (button.getAttribute('aria-busy') === 'true') return;

    const sectionId = this.dataset.sectionId;
    const grid = this.querySelector('[data-product-list]');
    const label = button.querySelector('[data-load-more-label]');
    const status = this.querySelector('[data-load-more-status]');
    const readyLabel = 'View More Pieces';

    if (!sectionId || !(grid instanceof HTMLElement)) return;

    button.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Loading More Pieces…';

    try {
      const url = new URL(button.href);
      url.searchParams.set('section_id', sectionId);

      const response = await fetch(url.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (!response.ok) throw new Error(`Unable to load products: ${response.status}`);

      const markup = await response.text();
      const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
      const nextGrid = documentFragment.querySelector('[data-product-list]');
      const newProducts = nextGrid?.querySelectorAll(':scope > .pathrohi-product-grid__item');

      if (!newProducts?.length) throw new Error('No additional products were returned.');

      const appendedProducts = Array.from(newProducts);
      grid.append(...appendedProducts);

      const nextButton = documentFragment.querySelector('[data-load-more]');

      const nextUrl = nextButton?.getAttribute('href');
      if (nextButton instanceof HTMLAnchorElement && nextUrl) {
        button.setAttribute('href', nextUrl);
        button.removeAttribute('aria-busy');
        if (label) label.textContent = readyLabel;
      } else {
        button.remove();
      }

      if (status) status.textContent = `${appendedProducts.length} more pieces loaded.`;
    } catch (error) {
      button.removeAttribute('aria-busy');
      if (label) label.textContent = 'Try Loading Again';
      if (status) status.textContent = 'More pieces could not be loaded. Please try again.';
      console.error(error);
    }
  }
}

if (!customElements.get('pathrohi-catalogue')) {
  customElements.define('pathrohi-catalogue', PathrohiCatalogue);
}
